import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { BadgeModule } from '../common/badge/badge.module';
import { ButtonModule } from '../common/button/button.module';
import { IconModule } from '../common/icon/icon.module';
import { FeatureTooltipComponent } from './feature-tooltip.component';
import {
  FeatureTooltipDirective,
  FeatureTooltipDirectiveConfig,
} from './feature-tooltip.directive';

@NgModule({
  imports: [CommonModule, I18nModule, BadgeModule, ButtonModule, IconModule],
  declarations: [FeatureTooltipComponent, FeatureTooltipDirective],
  entryComponents: [FeatureTooltipComponent],
  exports: [FeatureTooltipComponent, FeatureTooltipDirective],
})
export class RtFeatureTooltipModule {}

export { FeatureTooltipDirectiveConfig, FeatureTooltipDirective, FeatureTooltipComponent };
